module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-broad-beehive"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-beehive"
  }, [_c('div', {
    staticClass: "box-parent box-color-1"
  }, [_c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxOne(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_one")))])])])]), _c('div', {
    staticClass: "box-parent box-color-2"
  }, [_c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxTwo(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_two")))])])]), _c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxThree(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_three")))])])])]), _c('div', {
    staticClass: "box-parent box-color-3"
  }, [_c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxFour(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_four")))])])]), _c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxFive(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_five")))])])]), _c('div', {
    staticClass: "item-beehive",
    on: {
      "click": function($event) {
        _vm.onBoxSix(_vm.$t('home.comming_soon'))
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.beehive.box_six")))])])])])]), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93eac488","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Body/Beehive/index.vue
// module id = 1628
// module chunks = 0